// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__b3BeA","tab":"Tabs_tab__hN-uQ","tabActive":"Tabs_tabActive__1lI_6"};